import api from "api"

const faq = {
    get: (slug) => {
        return api().get(`/events/detail/${slug}/faqs`)
    },
    create: (slug, payload) => {
       return api().post(`/events/detail/${slug}/faqs`, payload);
    },
    update: (slug, payload, id) => {
       return api().put(`/events/detail/${slug}/faqs/${id}`, payload);
    },
    delete: (slug, id) => {
        return api().delete(`/events/detail/${slug}/faqs/${id}`);
    }
}

export default faq;